export default function AboutFormat() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        {/* Badge */}
        <div className="flex justify-center mb-6">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{ background: 'rgba(43,111,212,0.1)', color: '#1A3A8F' }}>
            <i className="ri-mic-line"></i>
            <span className="font-semibold text-sm whitespace-nowrap">Formato do Episódio</span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-8 leading-tight">
          Seu episódio, sua história,<br />
          <span className="font-serif italic" style={{ color: '#2B6FD4' }}>seu momento de brilhar ✨</span>
        </h2>

        {/* Content Box */}
        <div className="rounded-3xl p-8 md:p-12 shadow-sm" style={{ background: '#f0f5ff' }}>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            O <strong>Manaus Digital Podcast</strong> tem um formato de <strong>bate-papo em roteiro fechado</strong> — ou seja, a conversa é guiada por uma estrutura pensada para fluir de forma natural, mas você tem total liberdade para falar dos temas que desejar dentro do seu universo.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Não é uma entrevista engessada. É uma conversa <strong>descontraída e autêntica</strong>, onde você se sente à vontade para compartilhar sua trajetória, experiências, visões e aprendizados — do jeito que quiser contar.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            E no <strong>momento final do episódio</strong>, você tem um espaço exclusivo para <strong>divulgar o seu negócio</strong>: apresentar seus produtos, serviços, redes sociais e tudo que quiser que o público conheça sobre você.
          </p>
        </div>

        {/* Key Points */}
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          <div className="text-center">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(43,111,212,0.1)' }}>
              <i className="ri-file-list-3-line text-3xl" style={{ color: '#2B6FD4' }}></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Roteiro Fechado</h3>
            <p className="text-gray-600 text-sm">Estrutura pensada para garantir uma conversa fluida, dinâmica e com começo, meio e fim</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(0,191,255,0.12)' }}>
              <i className="ri-chat-smile-3-line text-3xl" style={{ color: '#00BFFF' }}></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Liberdade Total</h3>
            <p className="text-gray-600 text-sm">Você fala dos temas que desejar, do jeito que se sentir mais à vontade</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(26,58,143,0.1)' }}>
              <i className="ri-megaphone-line text-3xl" style={{ color: '#1A3A8F' }}></i>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Divulgue seu Negócio</h3>
            <p className="text-gray-600 text-sm">Espaço exclusivo no final do episódio para apresentar seus produtos e serviços ao público</p>
          </div>
        </div>
      </div>
    </section>
  );
}
